<template>
  <transition name="fade">
    <div v-show="done">
      <NavBar title="Geeker" />
      <div class="fix">
        <div class="wave">

        </div>
        <h1 style="position: absolute; top: 100px;   text-align: center; color: white; width: 100%; ">Having Tech Issues?
          <p style="position: relative;  color: #bdbdbd; font-size: 15pt; padding-top: 10px ">
            Describe your issue below and get support fast!
          </p>
        </h1>

        <b-container>

          <TicketForm style="position: relative; top: -100px; " v-on:createnewticket="createTicket($event)" />

        </b-container>
      </div>

      <!--Ticket List-->
      <TicketList :tickets=tickets v-on:closeTickets="closeTicket($event)" v-on:createServiceNow="serviceNow($event)" />

    </div>

  </transition>
</template>

<script>
import axios from "axios";
import NavBar from "@/components/NavBar/NavBar";
import TicketList from "@/components/TicketList/TicketList.vue";
import TicketForm from "@/components/Form/TicketForm.vue";
import db from "../firebaseInit";

export default {
  name: "Home",
  components: { TicketList, TicketForm, NavBar },
  data() {
    return {
      done: false,
      tickets: []
    };
  },
  firestore() {
    return {
      tickets: db.collection("tickets").orderBy("createdAt")
    };
  },
  methods: {
    createTicket: function(Description) {
      db.collection("tickets").add({
        description: Description,
        name: localStorage.getItem("name"),
        user: localStorage.getItem("user"),
        createdAt: new Date(),
        chat: [
          {
            user: "Blake Mastrud",
            message: "Try Restart!",
            createdAt: new Date()
          },
          { user: "Cindy Wilson", message: "Ok thanks ", createdAt: new Date() }
        ]
      });
    },
    closeTicket: function(id) {
      // <-- and here
      db
        .collection("tickets")
        .doc(id)
        .delete()
        .then(data => {
          console.log("Ticket Deleted Successfully");
        })
        .catch(err => console.log(err));
    },
    serviceNow: function(info) {
      let ticketInfo = JSON.stringify({
        short_description: "Testing!!!!!!!!!!!!!",
        assigned_to: "bmastrud",
        assignment_group: "ConsumerServices_Tier2",
        caller_id: "cwilson2",
        password: info.password,
        comments: `Ticket Created By GetAGeek\n Affected User: test \n Responsible Tech: bmastrud`,
        cmTickets_ci: ""
      });
    }
  },
  mounted() {
    this.done = true;
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fix .wave {
  position: relative;
  width: 100%;
  padding: 200px;
  left: 0px;
  top: 0px;
  z-index: -1;
  background-color: #3e606f;
  overflow: hidden;
}
.fix .wave:before,
.fix .wave:after {
  content: "";
  position: absolute;
  left: 50%;
  min-width: 400vw;
  min-height: 400vw;
  background-color: #2c2e2b;
  -webkit-animation-name: rotates;
  animation-name: rotates;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
}
.fix .wave:before {
  bottom: 19vh;
  border-radius: 45%;
  -webkit-animation-duration: 10s;
  animation-duration: 10s;
}
.fix .wave:after {
  bottom: 16vh;
  opacity: 0.5;
  border-radius: 47%;
  -webkit-animation-duration: 10s;
  animation-duration: 10s;
}

@-webkit-keyframes rotates {
  0% {
    -webkit-transform: translate(-50%, 0) rotateZ(0deg);
    transform: translate(-50%, 0) rotateZ(0deg);
  }
  50% {
    -webkit-transform: translate(-50%, -2%) rotateZ(180deg);
    transform: translate(-50%, -2%) rotateZ(180deg);
  }
  100% {
    -webkit-transform: translate(-50%, 0%) rotateZ(360deg);
    transform: translate(-50%, 0%) rotateZ(360deg);
  }
}

@keyframes rotates {
  0% {
    -webkit-transform: translate(-50%, 0) rotateZ(0deg);
    transform: translate(-50%, 0) rotateZ(0deg);
  }
  50% {
    -webkit-transform: translate(-50%, -2%) rotateZ(180deg);
    transform: translate(-50%, -2%) rotateZ(180deg);
  }
  100% {
    -webkit-transform: translate(-50%, 0%) rotateZ(360deg);
    transform: translate(-50%, 0%) rotateZ(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Views/Home.vue